module.exports = __webpack_public_path__ + "static/media/cpd-header.b3b9fe5a.png";